import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { CmsPage } from '@/types'

import { getPageBySlug } from '@/lib/db/pages'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import HeroSection from '@/components/landing/hero-section'
import HomeContentSection from '@/components/landing/home-content-section'
import { HOME_PAGE_SLUG, siteConfig } from '@/constants/site'

interface HomeProps {
    page: CmsPage | null
}

const Home: FC<HomeProps> = ({ page }): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HeroSection title={page?.title ?? siteConfig.name} />

            {page && <HomeContentSection page={page} />}
        </Layout>
    )
}

export const getServerSideProps: GetServerSideProps<HomeProps> = async () => {
    try {
        return { props: { page: await getPageBySlug(HOME_PAGE_SLUG) } }
    }
    catch (error) {
        console.error('Could not load the home page content:', error instanceof Error ? error.message : error)

        return { props: { page: null } }
    }
}

export default Home
